import { render, staticRenderFns } from "./TopCustomerChart.vue?vue&type=template&id=218df053&scoped=true"
import script from "./TopCustomerChart.vue?vue&type=script&lang=js"
export * from "./TopCustomerChart.vue?vue&type=script&lang=js"
import style0 from "./TopCustomerChart.vue?vue&type=style&index=0&id=218df053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218df053",
  null
  
)

export default component.exports